var _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternPricing6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 986.42 1359.75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m235 494.44-6.41 20.62-20.59-6.42a32.39 32.39 0 0 1 -21.31-40.56l6.42-20.62 20.62 6.41a32.4 32.4 0 0 1 21.27 40.57z",
    fill: "#f5365c",
    transform: "translate(-74.1 -219.19)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 939.64,
    cy: 209.9,
    fill: "#172b4d",
    r: 41.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-74.1 -219.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1049.37 1420.51v158.43h-158.82c0-87.5 71.11-158.43 158.82-158.43z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1049.37 1506.24v72.7h-72.88a72.79 72.79 0 0 1 72.88-72.7z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.93 269.61-2.77-2.13 2.13-2.77a116.51 116.51 0 0 1 163.37-21.4l2.77 2.13-2.13 2.77a116.5 116.5 0 0 1 -163.37 21.4z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.9 455.22a116.5 116.5 0 0 1 -21.4-163.36l2.13-2.78 2.77 2.13a116.51 116.51 0 0 1 21.4 163.37l-2.13 2.77z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.94 801.14c47.59 32.83 58.53 99.5 24.44 148.93-47.59-32.82-58.53-99.5-24.44-148.93z",
    fill: "#f5365c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1041.23 595.35 2.34-.58.59 2.43c11 44.61-14.94 89.35-57.9 99.92l-2.33.58-.6-2.43c-10.98-44.61 14.94-89.35 57.9-99.92z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1000.9 1393.75a43.07 43.07 0 1 1 -43.06 43.07 43.07 43.07 0 0 1 43.06-43.07z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001.12 1411.11a25.92 25.92 0 1 1 -25.93 25.89 25.92 25.92 0 0 1 25.93-25.89z",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1001.54 1423.59a13.86 13.86 0 1 1 -13.86 13.86 13.86 13.86 0 0 1 13.86-13.86z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.22 298.72 1.31-61.88-61.88-1.31a62.52 62.52 0 0 0 -63.82 61.18l-1.31 61.88 61.87 1.31a62.52 62.52 0 0 0 63.83-61.18z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m972.48 297.2a45.42 45.42 0 1 0 -90.81-1.92l-1 45.4 45.41 1a45.41 45.41 0 0 0 46.4-44.48z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.54 313.07v60.15a60.45 60.45 0 1 0 60.46-60.15z",
    fill: "#11cdef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternPricing6);
export default __webpack_public_path__ + "static/media/pattern_pricing6.bddb9fa151a57e78bfded53acd677472.svg";
export { ForwardRef as ReactComponent };